




















import Vue from "vue";

export default Vue.extend({
  name: "RenameAccount",
  props: {
    settingModel: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      rules: {
        accountName: [
          {
            required: true,
            message: "Please fill in your account name",
            trigger: "change",
          },
          {
            type: "string",
            max: 30,
            message: "Max 30 characters.",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    showModal(): any {
      return this.showEditor;
    },
  },
  watch: {
    showModal(newVal) {},
  },
  methods: {
    handleCancel() {
      (this.$refs.SetupForm as any).resetFields();
      this.$emit("cancel");
    },
    handleHidden(visible) {
      if (!visible) {
        try {
          (this.$refs.SetupForm as any).resetFields();
        } catch (error) {}
      }
    },
    handleSave(event) {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      (this.$refs.SetupForm as any).validate((valid: boolean) => {
        if (valid) {
          let dto = {
            accountName: this.settingModel.accountName,
          };

          let context = this;
          context.$store.dispatch("billing/renameAccount", { data: dto }).then(() => {
            context.$Notice.success({
              title: "Rename Account",
              desc: "Success! ",
            });
            context.$emit("cancel");
            target.disabled = false;
            (this.$refs.SetupForm as any).resetFields();
          });
        } else {
          target.disabled = false;
        }
      });
    },
  },
});
